const STORAGE_KEYS = {
  USER: 'childUser',
  AVATAR: 'childAvatar',
  ID: 'childId',
  NOMBRE: 'childNombre',
  EDAD: 'childEdad',
  COLORES: 'coloresEmocion',
  DRAWING: 'howeDrawing'
};

export const storageService = {
  saveChildData(childData) {
    const userObject = {
      id: childData.child_id,
      nombre: childData.nombre,
      rol: 'child',
      edad: childData.edad,
      avatar: childData.avatar || {
        name: childData.nombre,
        gender: childData.genero || 'boy',
        genderId: childData.genero === 'girl' ? 1 : 0,
        skin: 0,
        hair: 0,
        eyes: 0,
        mouth: 0,
        pants: 0,
        shirt: 0,
        shoes: 0
      }
    };

    // Guardamos solo el objeto principal
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(userObject));
  },

  getChildData() {
    const userData = localStorage.getItem(STORAGE_KEYS.USER);
    return userData ? JSON.parse(userData) : null;
  },

  clearChildData() {
    Object.values(STORAGE_KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
  },

  updateAvatar(avatarData) {
    const userData = this.getChildData();
    if (userData) {
      userData.avatar = avatarData;
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(userData));
    }
  },

  clearAllData() {
    Object.values(STORAGE_KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
  },

  logout() {
    this.clearAllData();
    window.location.href = '/'; // Redirige al inicio
  }
};